import { styled } from '@mui/material/styles';
import isPropValid from '@emotion/is-prop-valid';

export const Root = styled('div', { shouldForwardProp: isPropValid })(({ imgUrl }) => ({
  color: 'white',
  position: 'relative',
  overflow: 'hidden',
  '&.image-background': {
    background: `url('${imgUrl}') no-repeat center center`,
    backgroundSize: 'cover',
    height: '450px',
    maxHeight: '800px',
    '@media screen and (min-width: 800px)': {
      height: '80vh',
      minHeight: '480px',
    },
  },
  '&.video-background': {
    minHeight: '480px',
    width: '100%',
  },
}));

export const StyledContainer = styled('div', { shouldForwardProp: isPropValid })(
  ({ theme, verticalAlignment, cardStyle, alignRight }) => ({
    position: 'absolute',
    bottom: 0,
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2rem 1rem',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('sm')]: {
      justifyContent: `${
        verticalAlignment === 'top'
          ? 'flex-start'
          : verticalAlignment === 'bottom'
          ? 'flex-end'
          : 'center'
      }`,
      padding: '3rem',
    },
    [theme.breakpoints.up('lg')]: {
      padding: `3rem ${cardStyle ? '3rem' : '7rem'}`,
    },
    '&.black-overlay': {
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 0, 0, 0), rgba(0, 0, 0, 0.6))',
      height: '100%',
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        backgroundImage: `linear-gradient(
                to ${alignRight ? 'right' : 'left'},
                rgba(0, 0, 0, 0),
                rgba(0, 0, 0, 0.7)
              )`,
      },
    },
    '.card-style & .card-content': {
      backgroundColor: `rgba(37, 40, 42, 0.9)`,
      borderRadius: '5px',
      padding: '2rem 1.5rem',
      [theme.breakpoints.up('sm')]: {
        padding: '2.5rem 3rem',
      },
      [theme.breakpoints.up('lg')]: {
        padding: '3.5rem 4rem',
      },
    },
    '& .subtitle': {
      fontWeight: 'normal',
    },
    '& .animate': {
      position: 'relative',
      visibility: 'hidden',
    },
    '&.in-view .animate': {
      visibility: 'visible',
      transition: 'transform 0.8s ease-out',
    },
    '&.animate-right': {
      '& .animate': {
        transform: 'translate(700px, -20px)',
      },
      '&.in-view .animate': {
        transform: 'none',
      },
    },
    '&.animate-left': {
      '& .animate': {
        transform: 'translate(-700px, -20px)',
      },
      '&.in-view .animate': {
        transform: 'none',
      },
    },
    '&.animate-bottom': {
      '& .animate': {
        transform: 'translateY(700px)',
      },
      '&.in-view .animate': {
        transform: 'translateY(0)',
      },
    },
    '&.animate-left hr, &.animate-right hr': {
      transitionDelay: '0.07s',
    },
    '&.in-view': {
      '& p.animate': {
        transitionDelay: '0.07s',
      },
      '& .button-wrapper.animate': {
        transitionDelay: '0.14s',
      },
    },
  }),
);
